<template>
    <div>
        <br>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        class="form-control select"
                        v-model="search.customer"
                        :options="optionCustomer"
                        :customLabel="customerLabel"
                        :show-labels="false"
                        placeholder="ค้นหาลูกค้า"
                        track-by="id">
                    </multiselect> &nbsp;&nbsp;
                    <multiselect
                        class="form-control select"
                        v-model="search.sale"
                        :options="OptionSeller"
                        :customLabel="customSaleLabel"
                        :show-labels="false"
                        placeholder="ค้นหา Sale"
                        track-by="sale_id">
                    </multiselect> &nbsp;&nbsp;
                    <button @click="onClickSearch(1)"
                        class="btn btn-success my-2 my-sm-0"
                        type="button">
                        <icon name="search"></icon> ค้นหา
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th>ชื่อเซลล์</th>
                    <th>ชื่อลูกค้า</th>
                    <th>จังหวัด</th>
                    <th colspan="3">เหมา</th>
                    <th colspan="3">ห่อเล็ก</th>
                    <th colspan="3">ห่อใหญ่</th>
                    <th colspan="3">พ่วง(ห่อเล็ก)</th>
                    <th colspan="3">พ่วง(ห่อใหญ่)</th>
                    <th rowspan="2">แก้ไข</th>
                </tr>
                <tr>
                    <th colspan="3"></th>
                    <template v-for="data in transport_type">
                        <th>{{data.name}}</th>
                    </template>
                    <template v-for="data in transport_type">
                        <th>{{data.name}}</th>
                    </template>
                    <template v-for="data in transport_type">
                        <th>{{data.name}}</th>
                    </template>
                    <template v-for="data in transport_type">
                        <th>{{data.name}}</th>
                    </template>
                    <template v-for="data in transport_type">
                        <th>{{data.name}}</th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in transportFoamList">
                    <td>{{data.sale ? data.sale.sale_id: ''}} {{data.sale ? data.sale.name: ''}}</td>
                    <td>{{data.customer_id}} {{data.store_name}}</td>
                    <td>{{data.province ? data.province.name : ''}}</td>
                    <template v-if="data.transport_form.length > 0">
                        <template v-for="transport in data.transport_form">
                            <template v-for="item in transport">
                                <td>{{item.price}}</td>
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <template v-for="i in 5">
                            <template v-for="j in transport_type">
                                <td></td>
                            </template>
                        </template>
                    </template>
                    <td>
                        <a @click="showCustomerData(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="transportFoamList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="onClickSearch(dataPaginate.current_page)">
            </vue-pagination>
        </div>
        <br>
        <b-modal size="lg" hide-footer hide-header ref="edit_transport_fee">
            <edit-transport-foam-modal @submit="saveTransportFoam">
            </edit-transport-foam-modal>
        </b-modal>
        <b-modal hide-footer hide-header ref="loading">
           <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import VuePagination from "../../Pagination";
    import EditTransportFoamModal from "./EditTransportFoamModal";
    import Loading from "../../Utility/Loading";
    import Multiselect from "vue-multiselect";

    export default {
        name: "TransportFoamList",
        components: {Loading, EditTransportFoamModal, VuePagination,Multiselect},
        data(){
            return {
                transportFoamList : [],
                status_loading : 1,
                msg : '',
                optionCustomer : [],
                dataPaginate:{
                    current_page :1,
                    from : 1,
                    last_page : 1,
                    per_page : 1,
                    total : 1,
                    to : 1
                },
                search:{
                    customer : null,
                    sale : null,
                }
            }
        },
        created() {
            this.getCustomerTable(1);
            this.getCustomerAll();
            this.$store.dispatch("TransportType/transportTypeAll");
        },
        computed: {
            ...mapState({
                user: state => {
                    return state.Auth.user;
                },
                transport_type:state=>{
                    return state.TransportType.transport_type_all.filter(data=>data.id != 4)
                },
                OptionSeller: state =>{
                    return state.Seller.data;
                },
            }),
        },
        methods:{
            showLoadingModal() {
                this.$refs.loading.show();
            },
            hideLoadingModal() {
                this.$refs.loading.hide();
            },
            showEditTransportFeeModal() {
                this.$refs.edit_transport_fee.show();
            },
            hideEditTransportFeeModal() {
                this.$refs.edit_transport_fee.hide();
            },
            customSaleLabel (option) {
                return `${option.sale_id} - ${option.name}`
            },
            customerLabel(option){
                return `${option.customer_id} - ${option.store_name}`
            },
            showCustomerData(id){
              this.$store.dispatch("Customer/show",id).then(()=>{
                  this.showEditTransportFeeModal();
              })
            },
            getCustomerAll(){
                this.$store.dispatch("Customer/setAllCustomer").then(res=>{
                    this.optionCustomer = res;
                });
            },
            onClickSearch(page){
                this.showLoadingModal();
                this.status_loading = 1;
                this.msg = "กำลังบันทึกข้อมูล กรุณารอสักครู่"
                this.getCustomerTable(page);
            },
            getCustomerTable(page){
                let data = {
                    customer_id : this.search.customer ? this.search.customer.id : '',
                    sale_id : this.search.sale ? this.search.sale.id : '',
                }
                this.$store.dispatch("Customer/getCustomerTransportEdit",{
                    page,
                    data,
                }).then(res=>{
                    this.transportFoamList = res.data;
                    this.dataPaginate = {
                        current_page : res.current_page,
                        from : res.form,
                        last_page : res.last_page,
                        per_page : res.per_page,
                        total : res.total,
                        to : res.to
                    };
                }).then(()=>{
                    this.hideLoadingModal();
                });
            },
            saveTransportFoam(value){
                if(value){
                    this.showLoadingModal();
                    this.status_loading = 1;
                    this.msg = "กำลังบันทึกข้อมูล กรุณารอสักครู่"
                    this.$store.dispatch("Customer/saveTransportFeeCustomer",value).then(()=>{
                        this.getCustomerTable(this.dataPaginate.current_page);
                        this.hideLoadingModal();
                    }).catch(err=>{
                        console.log(err)
                        this.status_loading = 3;
                        this.msg = "บันทึกข้อมูลไม่สำเร็จ"
                    })
                }
                this.hideEditTransportFeeModal();
            }
        }
    }
</script>

<style scoped>
    .select {
        border: 0;
    }
</style>
